module.exports = __webpack_public_path__ + "img/banner-home.fefe9d72.jpg";